var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Aggregate", {
    attrs: {
      title: "Inverter",
      ItemConstructor: _vm.CaseModel.Inverter,
      headers: _vm.CaseModel.Inverter.HEADERS,
      cardProps: { flat: true, class: [] },
      "toolbar-dense": "",
      dense: "",
    },
    scopedSlots: _vm._u([
      {
        key: "item.power_capacity",
        fn: function (ref) {
          var item = ref.item
          return [
            _c("p", { staticClass: "mb-2" }, [
              _vm._v(_vm._s(item.power_capacity) + " MVA"),
            ]),
          ]
        },
      },
      {
        key: "default",
        fn: function (ref) {
          var item = ref.item
          return [
            _c(
              "v-card",
              { staticClass: "pa-2 ma-2", attrs: { flat: "" } },
              [
                _c(
                  "v-card-text",
                  [
                    _c(
                      "v-card",
                      { staticClass: "mb-6", attrs: { flat: "" } },
                      [
                        _c(
                          "p",
                          { staticClass: "text-subtitle-1 font-weight-bold" },
                          [_vm._v("Capacity")]
                        ),
                        _c(
                          "v-row",
                          { attrs: { dense: "" } },
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "6" } },
                              [
                                _c("InputTextField", {
                                  attrs: {
                                    label: _vm.schema.power_capacity.title,
                                    hint: _vm.schema.power_capacity.tooltip,
                                    suffix: _vm.schema.power_capacity.unit,
                                    "label-size": 8,
                                    type: "number",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$emit("change")
                                    },
                                  },
                                  model: {
                                    value: item.power_capacity,
                                    callback: function ($$v) {
                                      _vm.$set(item, "power_capacity", $$v)
                                    },
                                    expression: "item.power_capacity",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "6" } },
                              [
                                _c("ChartPlotly", {
                                  attrs: {
                                    data: [],
                                    layout: _vm.capabilityChartLayout(item),
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("v-divider", { staticClass: "mt-4" }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
    model: {
      value: _vm.computedValue,
      callback: function ($$v) {
        _vm.computedValue = $$v
      },
      expression: "computedValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }